export default __webpack_public_path__ + "static/media/prabu1.64fb86da.png";